import type { CollectionEventDependencies } from '../CollectionEventController';
import { getCurrentEventInstance } from './collectionEventUtils';
import { CollectionEventPopup } from '../views/CollectionEventPopup';
import { preloadLayoutsAssets } from '../../../views/preloadLayoutsAssets';
import { preloadCollectionEventAssets } from '../views/preloadCollectionEventAssets';

export async function openCollectionEventPopup(
  dependencies: CollectionEventDependencies,
  intro = false,
): Promise<void> {
  const { popupsController } = dependencies;

  const eventInstance = getCurrentEventInstance(dependencies);
  if (!eventInstance) return Promise.resolve();

  if (!(await preloadCollectionEventAssets(eventInstance.visuals))) return Promise.resolve();
  if (!(await preloadLayoutsAssets(CollectionEventPopup.requiredLayouts, true))) return Promise.resolve();

  const popup = new CollectionEventPopup(eventInstance, dependencies.observable.getValue().language);
  if (intro) void popup.switchToHelpView(true);

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  void popupsController.addPopup(popup);

  popup.onCloseClicked.connect(async () => {
    await popupsController.closeActivePopup();
    resolve();
  });

  popup.onHelpClicked.connect(() => {
    void popup.switchToHelpView();
  });

  popup.onCloseHelpClicked.connect(() => {
    void popup.switchToRewardView();
  });

  return promise;
}
